import React, { useState, useEffect } from "react";
import "./Login.css";
import api from "../../api/Api.js";
import { useNavigate, useSearchParams } from "react-router-dom";


function Login() {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [getLogindata, setLogindata] = useState([]);

  const [captcha, setCaptcha] = useState({
    question:"",
    answer:0
  });

  const [captchaAnswer, setCaptchaAnswer] = useState("");

  const [errors, setErrors] = useState({});


  const navigate = useNavigate();

  const [searchParams] = useSearchParams();



  // Generate Captcha

  const generateCaptcha = () => {

    const num1 = Math.floor(Math.random()*10)+1;
    const num2 = Math.floor(Math.random()*10)+1;


    setCaptcha({

      question:`${num1} + ${num2} = ?`,
      answer:num1 + num2

    });


    setCaptchaAnswer("");

  };



  useEffect(()=>{

    generateCaptcha();

  },[]);




  // Login Submit

  const handleSubmit = async()=>{


    let newErrors = {};



    // User ID Check

    if(!email.trim()){

      newErrors.email="User ID is required";

    }



    // Password Check

    if(!password.trim()){

      newErrors.password="Password is required";

    }




    // Captcha Check

    if(!captchaAnswer.trim()){

      newErrors.captcha="Security Check is required";

    }

    else if(Number(captchaAnswer)!==captcha.answer){

      newErrors.captcha="Invalid Security Check";

    }



    setErrors(newErrors);



    if(Object.keys(newErrors).length > 0){

      return;

    }



    try{


      const res = await api.get(
        `/adminmod/loginProcess/${email}/${password}`
      );



      console.log("API RESPONSE",res.data);



      if(res.data?.data?.length > 0){


        setLogindata(res.data.data);



        const sessionId =
        res.data.data[0]?.user_id;



        localStorage.setItem(
          "SessionUserId",
          sessionId
        );



        navigate("/admin/dashboard");


      }
      else{


        setErrors({

          login:"Invalid User ID or Password"

        });


      }



    }
    catch(error){


      console.log(error);


      setErrors({

        login:"Login failed. Please try again."

      });


    }


  };





  // Session Login

  useEffect(()=>{


    const sessionId =
    searchParams.get("sessionId");


    if(sessionId){


      localStorage.setItem(
        "SessionUserId",
        sessionId
      );


      navigate(
        "/admin/dashboard",
        {
          replace:true
        }
      );

    }


  },[searchParams,navigate]);






return(

<div className="login-page">


<div className="login-card">



{/* LEFT PANEL */}

<div className="left-panel">


<div className="logo">

🎓

</div>



<p className="tag">
STUDENT MANAGEMENT SYSTEM
</p>



<h1>

Digital Campus
<br/>
Hub

</h1>



<p className="desc">

Your secure access point for managing academics,
admissions, finance and campus operations.

</p>



<div className="barcode"></div>


<span className="session">

ACCESS CARD • SESSION 2026

</span>


</div>





{/* RIGHT PANEL */}


<div className="right-panel">



<p className="small-title">

VERIFIED ACCESS

</p>




<h2>

Sign in to your account

</h2>





{
errors.login &&

<div className="login-error">

{errors.login}

</div>

}




<div className="input-box">


<label>
User ID
</label>



<input

type="text"

value={email}

onChange={(e)=>{

setEmail(e.target.value);

setErrors({
...errors,
email:""
});

}}

placeholder="e.g STU2026014"

/>


{

errors.email &&

<span className="error">

{errors.email}

</span>

}


</div>





<div className="input-box">


<label>

Password

</label>



<input

type="password"

value={password}

onChange={(e)=>{

setPassword(e.target.value);

setErrors({
...errors,
password:""
});

}}

placeholder="********"

/>



{

errors.password &&

<span className="error">

{errors.password}

</span>

}


</div>






<label className="label">

Security Check

</label>




<div className="captcha">



<div className="math">

{captcha.question}

</div>





<input

type="text"

value={captchaAnswer}

onChange={(e)=>{

setCaptchaAnswer(e.target.value);

setErrors({
...errors,
captcha:""
});

}}

placeholder="Answer"

/>





<button

type="button"

className="refresh"

onClick={generateCaptcha}

>

↻

</button>



</div>




{

errors.captcha &&

<span className="error">

{errors.captcha}

</span>

}





<br/>

<button

type="button"

onClick={handleSubmit}

className="login-btn"

>

Enter Portal

</button>





<div className="bottom">

<a href="/">

Forgot passcode?

</a>

</div>





<div className="footer">

© 2026 All Rights Reserved.

</div>



</div>




</div>


</div>


);


}


export default Login;